import { createRouter, createWebHistory } from 'vue-router'

import MainPage from '@/pages/MainPage.vue'
import AnimeTitle from '@/pages/AnimeTitle.vue'
import AnimeTitleWithStore from '@/pages/AnimeTitleWithStore.vue'
import NotFound from '@/pages/NotFound.vue'
import InfinityTitles from '@/pages/InfinityTitles.vue'
import AnimeCabinet from '@/pages/AnimeCabinet.vue'
import RegisterAnime from '@/pages/account/RegisterAnime.vue'
import AuthAnime from '@/pages/account/AuthAnime.vue'
import Forgot from '@/pages/account/Forgot.vue'
import Reset from '@/pages/account/Reset.vue'

const routes = [
    { path: '/', component: MainPage },
    { path: '/inf', component: InfinityTitles },
    { path: '/forgot', component: Forgot },
    { path: '/reset/:token', component: Reset },
    { path: '/cabinet', component: AnimeCabinet },
    { path: '/cabinet/favorite', component: AnimeCabinet },
    { path: '/cabinet/watched', component: AnimeCabinet },
    { path: '/cabinet/watching', component: AnimeCabinet },
    { path: '/cabinet/planned', component: AnimeCabinet },
    { path: '/cabinet/postponed', component: AnimeCabinet },
    { path: '/cabinet/droped', component: AnimeCabinet },
    { path: '/register', component: RegisterAnime },
    { path: '/auth', component: AuthAnime },
    { path: '/new_2023', component: InfinityTitles, props: true },
    { path: '/tv', component: InfinityTitles, props: true },
    { path: '/movie', component: InfinityTitles, props: true },
    { path: '/ova', component: InfinityTitles, props: true },
    { path: '/ona', component: InfinityTitles, props: true },
    { path: '/special', component: InfinityTitles, props: true },
    { path: '/filter', component: InfinityTitles, props: true },
    { path: '/not_found', component: NotFound},
    { path: '/store/:id', component: AnimeTitleWithStore, props: true },
    { path: '/:id', component: AnimeTitle, props: true },
    { path: '/studio/:id', component: InfinityTitles, props: true },
    { path: '/genre/:id', component: InfinityTitles, props: true },
    { path: '/writer/:id', component: InfinityTitles, props: true },
    { path: '/director/:id', component: InfinityTitles, props: true }
]

const router = createRouter({
  history: createWebHistory(process.env.BASE_URL),
  routes
})

export default router